import { Injectable } from '@angular/core';
import { CacheService } from '@delon/cache';
import { _HttpClient } from '@delon/theme';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IJsonTable, JsonTableData } from '@shared/model';

@Injectable({
  providedIn: 'root'
})
export class FunctionService {
  constructor(
    private http: _HttpClient,
    private cacheSvr: CacheService
  ) {}

  protected getUri(appType: number = 4): string {
    switch (appType) {
      case 1:
        return 'admin/v1/function/privilege_detail';
      case 6:
        return 'hospital/v1/function/privilege_detail';
      case 5:
        return 'distributor/v1/function/privilege_detail';
      case 3:
      case 4:
      default:
        return 'pharmacy/v1/function/privilege_detail';
    }
  }

  get(menu: string, appType: number = 4): Observable<JsonTableData> {
    return new Observable<JsonTableData>(observer => {
      this.cacheSvr
        .get<IJsonTable>(this.getUri(appType), {
          mode: 'promise',
          type: 'm',
          expire: 86400
        })
        .pipe(map(value => value.data))
        .subscribe(result => {
          observer.next(result as JsonTableData);
        });
    });
  }
}
